import React from 'react';
import { useTranslation } from 'react-i18next';

interface Card {
  key: string;
  href: string;
}

const cards: Card[] = [
  { key: 'promo1', href: '#promo1' },
  { key: 'signup', href: '#signup' },
  { key: 'login', href: '#login' },
];

const CTACards: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-dark_gray text-white py-8">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6">
        {cards.map(({ key, href }) => (
          <a
            key={key}
            href={href}
            className="
              flex-1
              border-[4px] border-[#d64b0f]
              text-[#d64b0f]
              bg-transparent
              text-center
              py-4
              rounded-[2rem]
              text-lg
              font-semibold
              transition
              hover:bg-[#d64b0f]
              hover:text-white
            "
          >
            {t(`cards.${key}`)}
          </a>
        ))}
      </div>
    </section>
  );
};

export default CTACards; 